import { render, staticRenderFns } from "./NewIndexItem.vue?vue&type=template&id=6ec59f7f&scoped=true&"
import script from "./NewIndexItem.vue?vue&type=script&lang=js&"
export * from "./NewIndexItem.vue?vue&type=script&lang=js&"
import style0 from "./NewIndexItem.vue?vue&type=style&index=0&id=6ec59f7f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec59f7f",
  null
  
)

export default component.exports